export enum PermissionsEnum {
    INVITE_OTHER_EMPLOYEES = 1,
    EDIT_COMPANY,
    EDIT_EMPLOYEE_PERMISSIONS,
    DELETE_EMPLOYEE_RELATIONS,
    ADD_PATIENT,
    EDIT_PATIENT,
    DELETE_PATIENT,
    EDIT_PROCEDURES_GROUPS,
    REGISTER_SCHEDULE,
    EDIT_SCHEDULE,
    DELETE_SCHEDULE,
    INVITE_EMPLOYEES_TO_SCHEDULE,
    EDIT_CLINIC,
    DELETE_CLINIC,
    ADD_INSURANCES_AND_INSURANCE_PLANS,
    EDIT_INSURANCE_AND_INSURANCE_PLANS,
    DELETE_INSURANCE_AND_INSURANCE_PLANS,
    CREATE_SCHEDULING,
    EDIT_SCHEDULING,
    DELETE_SCHEDULING,
    EDIT_DATASHEET,
    EDIT_INSURANCES_RELATIONS_WITH_PATIENTS,
    EDIT_INSURANCES_RELATIONS_WITH_SCHEDULES,
    EDIT_SCHEDULE_TIMETABLE_HOURS,
    EDIT_SCHEDULE_DOCTOR_RELATIONS,
    REGISTER_PROCEDURES,
    EDIT_PROCEDURES,
    DELETE_PROCEDURES,
    REGISTER_PROCEDURES_GROUPS,
    EDIT_PROCEDURES_IN_PROCEDURES_GROUPS,
    DELETE_PROCEDURES_GROUPS,
    ADD_ATTENDANCE_RECORD_OBSERVATIONS,
    EDIT_PROCEDURES_GROUPS_OF_SCHEDULE,
    EDIT_TIMETABLES_OF_SCHEDULE
}